import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DateTime } from 'luxon';

// The Calendar test card's body on the Test UI Components page: input-calendar with a date and empty.
@Component({
  selector: 'cs-test-calendar-card',
  host: { class: 'showcase-card-body' },
  template: `
    <cs-item-list>
      <cs-item>
        <cs-label data-test="calendar-test-header">Calendar test</cs-label>
      </cs-item>
      <cs-item vertical>
        <cs-label>Valid:</cs-label>
        <input-calendar item-right [date]="sampleDate" (dateChange)="sampleDateChange.emit($event)" [placeholder]="datePlaceholder"
          data-test="calendar-valid" />
      </cs-item>
      <cs-item vertical>
        <cs-label>Empty:</cs-label>
        <input-calendar item-right [(date)]="dateEmpty" [placeholder]="datePlaceholder" data-test="calendar-empty" />
      </cs-item>
    </cs-item-list>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestCalendarCardComponent {
  // the "Valid" field's date; the page shares it with the Control Outlines card's input-calendar
  @Input() sampleDate: string | undefined;
  @Output() sampleDateChange = new EventEmitter<string>();

  dateEmpty = undefined;
  readonly datePlaceholder = DateTime.local().minus({ year: 18 }).toISODate();
}
